import { FunctionComponent, useEffect, useState } from "react";
import commonStyles from "../../CommonStyles/CommonGraphStyles.module.css";
import IntBarChartOrg from "../IntBarChartOrg/IntBarChartOrg";
import IntBarTable from "../IntBarTable/IntBarTable";
import { Bar } from "react-chartjs-2";
import { colour_code } from '../../Values/constants';
import { CSVLink } from "react-csv";
import { connect } from "react-redux";
import { DownloadReportCsv } from "../CommanDownloadFunction";
import { themeColors } from "../../Components/theme";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import "../../theme-vars.css";

type props = {
  analyticsData: any;
  usersList: any;
  checked: boolean;
  teamsData: any;
  history: any;
  filter: "MTD" | "YTD" | "PM" | "All" | "CUSTOM";
  source: boolean;
  taskFilter: any;
  leadFilter: any;
  interestedProjectReportData: any;
  theme: any;
};

const InterestedProject: FunctionComponent<props> = ({
  analyticsData,
  usersList,
  checked,
  history,
  teamsData,
  filter,
  source,
  taskFilter,
  leadFilter,
  interestedProjectReportData,
  theme
}) => {

  /** ----------------------------------------------
*  Responsive Logic (MUI Breakpoints)
* ---------------------------------------------- */
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));

  /** ----------------------------------------------
*  CSV Download Data State
* ---------------------------------------------- */
  const [interestedProjectData, setInterestedProjectReportData] = useState<any>([]);
  const [interestedProjectReportHeader, setInterestedProjectReportHeader] = useState<any>([]);

  /** ------------------------------------------------
* Extract headers from callback reason data
* ------------------------------------------------ */
  useEffect(() => {
    let headerArray: any[] = [];
    interestedProjectReportData?.map((list: any) => {
      return list?.project?.map((li: any) => {
        return headerArray.push(li.project);
      })
    })
    setInterestedProjectReportHeader(headerArray)
  }, [interestedProjectReportData]);

  /** ------------------------------------------------
* Download CSV
* ------------------------------------------------ */
  const downLoadReport = () => {
    const csvReportData = DownloadReportCsv(interestedProjectReportData, interestedProjectReportHeader, usersList, 'project');
    setInterestedProjectReportData(csvReportData);
  }


  /** ------------------------------------------------
* Reusable styling for tables/cards by theme
* ------------------------------------------------ */
  const tableContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

  /** CSS Variables */
  const fontFamilyMain = "var(--font-family-main)";
  const fontSizeMedium = "var(--font-size-medium)";

  return (
    <>
      <Box className={`d-flex flex-column ${isMobile ? 'mb-2' : 'mb-3'}`} sx={{
        width: "100%",
        padding: isMobile ? 1 : 0,
      }}>
        <Box className="d-flex flex-column mb-2">

          {/* -------------------------------------------------------
       * Header Section with CSV Download Icon
       * ------------------------------------------------------- */}
          <h6
            className={commonStyles.heading}
            style={{ fontFamily: fontFamilyMain, fontSize: fontSizeMedium, margin: isMobile ? "0px 0px 10px 5px" : "0px 0px 10px 0px" }}
          >
            Interested Projects Summary
            <CSVLink onClick={downLoadReport} data={interestedProjectData}>
              {" "}
              <svg
                style={{ cursor: "pointer", color: "rgb(39, 159, 159)" }}
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-download"
                viewBox="0 0 16 16"
              >
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
              </svg>{" "}
            </CSVLink>
          </h6>

          {/* -------------------------------------------------------
       * Content Area (Chart + Table)
       * ------------------------------------------------------- */}
          <Box
            className="card p-4 shadow rounded"
            sx={{
              minWidth: "100%",
              maxWidth: "100%",
              minHeight: "350px",
              maxHeight: "350px",
              ...tableContainerStyles
            }}
          >
            <Box
              id="interestedProject"
              sx={{
                minWidth: "100%",
                maxWidth: "100%",
                overflowX: "auto",
                ...tableContainerStyles,
                color: "#000"
              }}
            >
              <IntBarChartOrg
                analyticsData={analyticsData}
                heading={"Interested Projects"}
                type={"project"}
                color={colour_code}
                GraphType={Bar}
                style={{ width: "100%", height: "350px" }}
                history={history}
                filter={filter}
              />
            </Box>
          </Box>

          {/* ----------------------
         * Table Box
         * ---------------------- */}
          <Box
            id="interestedProject"
            className="card p-4 shadow rounded w-100 mt-2"
            sx={{ minHeight: "350px", maxHeight: "350px", ...tableContainerStyles }}
          >
            <IntBarTable
              type={"project"}
              data={analyticsData}
              heading={"Interested Projects Summary"}
              usersList={usersList}
              checked={checked}
              teamsData={teamsData}
              style={{ width: "100%" }}
              show={false}
              filter={filter}
              history={history}
              source={source}
              taskFilter={taskFilter}
              leadFilter={leadFilter}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

/**
 * Maps Redux state to component props.
 */
const mapStateToProps = (state: any) => {
  return {
    interestedProjectReportData: state.interesteProjectData.data,
    theme: state.theme.isLightMode
  };
};
export default connect(mapStateToProps)(InterestedProject);

